import {
    AfterViewInit,
    Component,
    Input,
    OnChanges,
    ViewChild,
} from '@angular/core';
import { QuillEditorComponent } from '@app/shared/forms/quill-editor/quill-editor.component';

/**
 * Shows stored Quill HTML the same way Terms and Conditions does,
 * after the markup has been sanitized.
 */
@Component({
    selector: 'app-safe-rich-text',
    standalone: true,
    imports: [QuillEditorComponent],
    templateUrl: './safe-rich-text.component.html',
    styleUrl: './safe-rich-text.component.scss',
})
export class SafeRichTextComponent implements OnChanges, AfterViewInit {
    @Input() html = '';
    @Input() emphasizeLinks = false;

    @ViewChild(QuillEditorComponent) private editor?: QuillEditorComponent;

    private viewReady = false;

    ngOnChanges(): void {
        this.render();
    }

    ngAfterViewInit(): void {
        this.viewReady = true;
        this.render();
    }

    private render(): void {
        if (!this.viewReady || !this.editor) {
            return;
        }

        this.editor.writeValue(this.html || '');
    }
}
